// extracted by mini-css-extract-plugin
export var blackPill = "text-pill-module--blackPill--uWGjk";
export var container = "text-pill-module--container--EF6BW";
export var small = "text-pill-module--small--N8eWq";
export var tag = "text-pill-module--tag--xiF4x";
export var whitePill = "text-pill-module--whitePill--KBOnK";